<template>
  <div
    class="modal"
    v-bind:class="{
      'is-active': this.$store.state.popup.isActiveReplyQuestion
    }"
  >
    <div class="modal-background" @click="popupClose"></div>
    <div style="max-width:600px" class="modal-content">
      <div class="modalPoserQuestion">
        <img
          @click="popupClose()"
          src="@/assets/img/icons/close-icon.png"
          alt="close-icon"
          class="icon-close"
        />
        <div class="form_questionner">
          <div class="field">
            <div class="control has-text-centered">
              <div class="control backwhite">
                <b-input
                  name="response"
                  :value="this.$store.state.popup.responseQuestionText"
                  :placeholder="$t('public.reply_reponse')"
                  type="textarea"
                  @input="hydrateResponse"
                ></b-input>
              </div>
            </div>

            <b-upload
              accept="image/png,image/gif,image/jpeg,video/mp4"
              v-model="media"
              :input="checkFileSize()"
              v-bind:class="{
                'is-hidden': !this.$store.state.popup.responseQuestionText
              }"
            >
              <span style="font-size:12px;" v-if="!file"
                ><b-icon pack="fas" icon="image"></b-icon>
                {{ $t("public.illustrer_question") }}</span
              >
            </b-upload>

            <!-- Media currentMedia -->
            <div v-if="media" style="font-size:12px;">
              <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
              {{ $t("public.illustrer_ok") }}
              <span class="is-pulled-right" @click="removeMedia"
                ><b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon
              ></span>
            </div>

            <!-- Media from Database -->
            <div
              v-if="this.$store.state.popup.responseQuestionMedia"
              style="font-size:12px;"
            >
              <img
                :src="url_media + this.$store.state.popup.responseQuestionMedia"
                class="img_jointe"
              />
              <span class="is-pulled-right" @click="removeMediaStore"
                ><b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon
              ></span>
            </div>

            <div class="control has-text-right">
              <button
                class="button is-primary"
                @click="submitResponse"
                v-bind="{
                  disabled: !this.$store.state.popup.responseQuestionText
                }"
                v-bind:class="{ 'is-loading': this.sending }"
              >
                {{ $t("button.envoyer") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="button is-primary modal-close"
      aria-label="close"
      @click="popupClose"
    ></button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      file: null,
      media: null,
      sending: false,
      url_moderateur: this.$route.params.url_moderateur,
      url_media: process.env.URL_MEDIA
    };
  },
  props: {
    question_id: null,
    getQuestionsFirstTime: {
      required: true
    }
  },
  methods: {
    checkFileSize() {
      if (this.file && this.file.size > 6000000) {
        this.file = null;

        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.fichier_trop_lourd")
        });
      }
    },
    removeFile() {
      this.file = null;
    },
    removeMedia() {
      this.media = null;
    },
    removeMediaStore() {
      this.$store.state.popup.responseQuestionMedia = null;
    },
    hydrateResponse(textareaValue) {
      this.$store.commit(`HYDRATE_RESPONSE_INTITULE_QUESTION`, textareaValue);
    },
    submitResponse() {
      if (this.$store.state.popup.responseQuestionId) {
        // Update
        const form_values = new FormData();

        if (this.media) {
          form_values.append("mediaURL", this.media);
        } else if (!this.$store.state.popup.responseQuestionMedia) {
          form_values.append("mediaURL", "delete");
        }

        form_values.append(
          "response",
          this.$store.state.popup.responseQuestionText
        );

        this.sending = false;
        axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
        axios
          .post(
            process.env.URL_SSO_API +
              "textit/public/questions/" +
              this.question_id +
              "/responses/" +
              this.$store.state.popup.responseQuestionId,
            form_values
          )
          .then(response => {
            this.getQuestionsFirstTime();
            // On remet tout à null
            this.sending = false;
            this.response = "";
            this.file = null;
            this.media = null;
            this.popupClose();
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$i18n.t("public.envoiResponseOK")
            });
          })
          .catch(error => {
            this.sending = false;
            this.popupClose();
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("public.envoiKO")
            });
          });
      } else {
        // Post
        const form_values = new FormData();
        form_values.append("mediaURL", this.media);
        form_values.append(
          "response",
          this.$store.state.popup.responseQuestionText
        );

        this.sending = false;
        axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
        axios
          .post(
            process.env.URL_SSO_API +
              "textit/public/questions/" +
              this.question_id +
              "/responses",
            form_values
          )
          .then(response => {
             this.getQuestionsFirstTime();
            // On remet tout à null
            this.sending = false;
            this.response = "";
            this.file = null;
            this.media = null;
            this.popupClose();
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$i18n.t("public.envoiResponseOK")
            });
          })
          .catch(error => {
            this.sending = false;
            this.popupClose();
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("public.envoiKO")
            });
          });
      }
    },
    popupClose(evt) {
      this.$store.dispatch("popupToggleReplyQuestion");
    }
  }
};
</script>
<style scoped>
.modalPoserQuestion {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
  padding: 15px;
  background: #fff;
}
.icon-close {
  margin-bottom: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
.button {
  border-radius: 20px;
  font-size: 12px;
  color: white;
}

.img_jointe {
  margin: 5px 5px 5px 0;
  max-width: 230px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/PopupRepondreQuestion.vue